<template>
	<div class="c-spektrix-login c-spektrix-login__flex">
		<transition v-bind:name="animationName" mode="out-in">
			<div class="" v-if="loggedIn" key="loggedIn">
				<p>Logged in message</p>
				<a href="#" @click.prevent="logout()" class="o-button">Logout</a>
			</div>

			<form
				class="c-spektrix-login__aligned c-spektrix-login__flex o-form"
				v-else-if="!showForgotPassword"
				@submit.prevent="login()"
				key="mainView"
			>
				<div v-if="error" v-html="error" class="h-text--error"></div>
				<div class="c-form-field--text">
					<div class="c-form-field__inputset">
						<div class="c-form-field__input">
							<input
								type="text"
								v-model="username"
								placeholder="email address"
								autocomplete="on"
							/>
						</div>
					</div>
				</div>
				<div class="c-form-field--text">
					<div class="c-form-field__inputset">
						<div class="c-form-field__input">
							<input
								type="password"
								v-model="password"
								placeholder="password"
								autocomplete="current-password"
							/>
						</div>
					</div>
				</div>
				<button
					class="o-button"
					:class="{ 'o-button--loading': loading }"
					type="submit"
				>
					Login
				</button>
				<div class="c-spektrix-login__options">
					<a
						href=""
						@click.prevent="
							showForgotPassword = true;
							error = '';
						"
						>Forgotten password</a
					>
					<a href="/account/new">New account?</a>
				</div>
				<a
					class="c-spektrix-login__back"
					href="#"
					@click.prevent="backFromLogin()"
				>
					<span class="h-accessibility">Go back</span>
					<span class="c-paywall-cta__icon--close icon i-close">
						<crossIcon />
					</span>
				</a>
			</form>

			<form
				class="c-spektrix-login__aligned c-spektrix-login__flex"
				v-else-if="showForgotPassword"
				@submit.prevent="forgotPassword()"
				key="forgotPassword"
			>
				<div
					class="c-spektrix-login__error c-spektrix-login__spacing"
					v-if="error"
					v-html="error"
				></div>
				<div class="c-form-field--text">
					<div class="c-form-field__inputset">
						<div class="c-form-field__input">
							<input
								type="text"
								v-model="username"
								placeholder="email address"
								autocomplete="on"
							/>
						</div>
					</div>
				</div>
				<button
					class="c-spektrix-login__request c-spektrix-login__spacing o-button"
					type="submit"
					:class="{ 'o-button--loading': loading }"
				>
					Request password
				</button>
				<div class="c-spektrix-login__spacing" v-if="passwordSuccess">
					Thank you, follow the instructions on the email to reset you password
				</div>
				<a
					class="c-spektrix-login__back"
					href="#"
					@click.prevent="backFromForgotPassword()"
				>
					<span class="h-accessibility">Go back</span>
					<span class="c-paywall-cta__icon--close icon i-close">
						<crossIcon />
					</span>
				</a>
			</form>
		</transition>
	</div>
</template>

<script>
	import axios from "axios";

	import crossIcon from "/web/static/images/svgs/base-cross.svg?component";

	export default {
		name: "membership-cta",
		data: function () {
			return {
				username: "",
				password: "",
				error: false,
				loading: false,
				loggedIn: false,
				showForgotPassword: false,
				passwordSuccess: false,
				animationName: "a-forward-slide",
			};
		},
		components: {
			crossIcon,
		},
		props: {
			spektrixUrl: {
				type: String,
			},
		},
		mounted() {
			const self = this;

			//Check if user is already logged in
			axios
				.get(self.$props.spektrixUrl + "/api/v3/customer?$expand=tags", {
					withCredentials: true,
				})
				.then(function (response) {
					// If they are, emit the logged in event
					if ((response.status = 200)) {
						self.loggedIn = true;
						this.$emit("loggedIn");
					}
				})
				.catch(function (error) {});
		},
		methods: {
			login() {
				const self = this;
				self.loading = true;

				axios({
					method: "post",
					url: self.$props.spektrixUrl + "/api/v3/customer/authenticate",
					withCredentials: true,
					data: {
						email: self.username,
						password: self.password,
					},
				})
					.then(function (response) {
						if ((response.status = 204)) {
							self.loading = false;
							self.loggedIn = true;
							self.$emit("logged-in");
						}
					})
					.catch(function (error) {
						self.loading = false;

						self.error = "Wrong username/password";
					});
			},
			logout() {
				const self = this;
				self.loading = true;

				axios({
					method: "post",
					url: self.$props.spektrixUrl + "/api/v3/customer/deauthenticate",
					withCredentials: true,
				})
					.then(function (response) {
						self.loading = false;
						if ((response.status = 204)) {
							self.loggedIn = false;
						}
					})
					.catch(function (error) {
						self.loading = false;
					});
			},
			forgotPassword() {
				const self = this;
				self.animationName = "a-forwards-slide";

				if (self.username.length <= 0) {
					self.error = "Please enter a valid email address";
				} else {
					self.loading = true;

					axios({
						method: "post",
						url:
							self.$props.spektrixUrl +
							"/api/v3/customer/forgot-password?emailAddress=" +
							self.username,
						withCredentials: true,
					})
						.then(function (response) {
							//TODO: THIS
							self.loading = false;

							if ((response.status = 204)) {
								self.passwordSuccess = true;
							}
						})
						.catch(function (error) {
							self.loading = false;
							self.error =
								"We cannot find that email on our system, please try again";
						});
				}
			},
			backFromLogin() {
				this.animationName = "a-backward-slide";
				this.$emit("back-from-login");
			},
			backFromForgotPassword() {
				this.animationName = "a-backward-slide";
				this.$emit("back-from-forgot-password");
				this.showForgotPassword = false;
				this.error = "";
			},
		},
	};
</script>
